const TYPE_LABELS = {
  item: 'Item',
  element: 'Element',
  trade: 'Trade',
  section: 'Section',
  scope: 'Item'
};

export const inactiveItemTypeLabel = type => {
  const key = String(type || '')
    .trim()
    .toLowerCase();
  if (!key) return 'Item';
  return TYPE_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1);
};

const asItem = (raw, { tradeName = '', tradeId = '' } = {}) => {
  if (!raw || typeof raw !== 'object') return null;
  const name = String(raw.name || raw.scope_name || raw.title || '').trim();
  if (!name) return null;
  const id = raw.id || raw.scope_id || raw.element_id || name;
  return {
    id: String(id),
    name,
    type: raw.type || 'item',
    tradeName,
    tradeId
  };
};

const listFromTrade = trade => {
  if (!trade || typeof trade !== 'object') return [];
  const list = trade.inactive_items || trade.inactiveItems;
  return Array.isArray(list) ? list : [];
};

const tradesFromRecord = source => {
  if (Array.isArray(source)) return source;
  if (!source || typeof source !== 'object') return [];
  if (Array.isArray(source.trades_in_scope)) return source.trades_in_scope;
  if (Array.isArray(source.current_version?.trades_in_scope)) {
    return source.current_version.trades_in_scope;
  }
  return [];
};

/** Inactive catalog items live on each `trades_in_scope` row of the scope record. */
export const normalizeInactiveItems = source => {
  const seen = new Set();
  const items = [];
  tradesFromRecord(source).forEach(trade => {
    const tradeName = String(trade?.trade_name || trade?.name || '').trim();
    const tradeId = String(trade?.trade_id || trade?.id || '').trim();
    listFromTrade(trade).forEach(raw => {
      const item = asItem(raw, { tradeName, tradeId });
      if (!item || seen.has(item.id)) return;
      seen.add(item.id);
      items.push(item);
    });
  });
  return items;
};
